export default __webpack_public_path__ + "static/media/prx-dumbles.83f9b4d8.svg";